import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import './App.css';
import './styles/global.css';

import {
  pacientesStore,
  uhCollection,
  usersCollection,
  sessions,
  systems,
} from './utils/firebase';
import { compararInformación } from './utils/config';
import { ejecutarImportacionMedicosSiHaceFalta } from './utils/importarMedicosBoot';
import { analizarCalendarLog } from './utils/analizarCalendarLog';

import { obtenerPermisos } from './utils/perfiles';
import { MODO_DEMO, UNIDAD_DEMO } from './utils/demo';
import Login      from './views/Login';
import AgendaPage from './views/AgendaPage';

const VERSION = '1.0.1';

if (MODO_DEMO && typeof document !== 'undefined' && !document.title.startsWith('DEMO')) {
  document.title = `DEMO · ${document.title}`;
}

const App = () => {
  const [userIsLogged,    setUserIslogged]    = useState(sessionStorage.getItem('logged'));
  const [userName,        setUserName]        = useState(sessionStorage.getItem('name'));
  const [userNomHospital, setuserNomHospital] = useState(sessionStorage.getItem('nomHospital'));
  const [userCalendar,    setUserCalendar]    = useState(sessionStorage.getItem('calendar'));
  const [userLevel,       setUserLevel]       = useState(sessionStorage.getItem('level'));
  const [isCorporativo,   setIsCorporativo]   = useState(sessionStorage.getItem('nomHospital') === 'Corporativo');
  const [uhList,          setUhList]          = useState([]);
  const [sessionList,     setSessionList]     = useState([]);

  useEffect(() => {
    const unsub = pacientesStore.collection(sessions).onSnapshot((snap) => {
      const list = [];
      snap.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
      setSessionList(list);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = pacientesStore
      .collection(systems)
      .where('id', '==', '2')
      .onSnapshot((snap) => {
        snap.forEach((doc) => {
          if (doc.data().version !== VERSION) {
            // En pantallas (perfil Monitor) nadie da clic: se recarga sola a los 10 s
            const esMonitor = obtenerPermisos(sessionStorage.getItem('level')).soloAgenda;
            Swal.fire({
              ...(esMonitor ? { timer: 10000, timerProgressBar: true } : {}),
              icon: 'warning',
              title: 'Nueva versión disponible',
              text: 'Se recargará la página para actualizarse.',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#04afaa',
              allowOutsideClick: false,
            }).then((r) => { if (r.isConfirmed || esMonitor) window.location.reload(); });
          }
        });
      });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!userIsLogged) return;
    const unsubUH = pacientesStore.collection(uhCollection).onSnapshot((snap) => {
      const list = [];
      snap.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
      list.sort(compararInformación('hospital'));
      // Ambiente demo: en los selectores solo aparece Integración Procesos Clínicos (y Corporativo)
      const limpia = (t) => String(t || '').normalize('NFC').replace(/\s+/g, ' ').trim().toLowerCase();
      setUhList(MODO_DEMO
        ? list.filter((u) => limpia(u.calendar) === limpia(UNIDAD_DEMO) || u.hospital === 'Corporativo')
        : list);
    });
    return () => unsubUH();
  }, [userIsLogged]);

  // useEffect(() => {
  //   if (!userIsLogged) return;
  //   // Importación única del catálogo de médicos — no bloquea la carga de
  //   // la Agenda: corre en segundo plano y, salvo la primera vez que
  //   // alguien la ejecuta, es solo una lectura pequeña (bandera ya
  //   // completada) sin costo real. Ver comentarios en el propio archivo.
  //   ejecutarImportacionMedicosSiHaceFalta();
  // }, [userIsLogged]);

  //ejecutarImportacionMedicosSiHaceFalta()

  useEffect(() => {
    if (!userIsLogged) return;
    // Análisis de calendarlog al cargar el login — de solo lectura, no
    // escribe nada. Resultado visible en la consola del navegador
    // (console.log), no en la interfaz. Ver comentarios en el propio
    // archivo para el detalle de qué campos extrae y cómo hace el merge
    // contra la colección de usuarios.
    //analizarCalendarLog();
  }, [userIsLogged]);

  //analizarCalendarLog();

  if (userIsLogged && userName && userNomHospital && userLevel) {
    return (
      <AgendaPage
        userName           = {userName}
        userNomHospital    = {userNomHospital}
        userCalendar       = {userCalendar}
        userLevel          = {userLevel}
        isCorporativo      = {isCorporativo}
        uhList             = {uhList}
        setuserNomHospital = {setuserNomHospital}
        setUserCalendar    = {setUserCalendar}
        onLogout={() => {
          sessionStorage.clear();
          setUserIslogged(null);
          setUserName(null);
          setuserNomHospital(null);
          setUserCalendar(null);
          setUserLevel(null);
        }}
      />
    );
  }

  return (
    <Login
      setuserNomHospital = {setuserNomHospital}
      setUserCalendar    = {setUserCalendar}
      setUserName        = {setUserName}
      setUserIslogged    = {setUserIslogged}
      setUserLevel       = {setUserLevel}
      sessionList        = {sessionList}
      setIsCorporativo   = {setIsCorporativo}
    />
  );
};

export default App;